import { extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';

var FIELD_TYPE = /*#__PURE__*/Symbol('FIELD');
var FORM_TYPE = /*#__PURE__*/Symbol('FORM');
var isForm = function isForm(field) {
  return field['#type'] === FORM_TYPE;
};
var createField = function createField(validators, metadata) {
  if (validators === void 0) {
    validators = [];
  }

  return {
    '#type': FIELD_TYPE,
    validators: validators,
    metadata: metadata
  };
};
var createForm = function createForm(fields) {
  var fieldsByName = fields.reduce(function (result, _ref) {
    var _extends2;

    var name = _ref[0],
        field = _ref[1];
    return _extends({}, result, (_extends2 = {}, _extends2[name] = field, _extends2));
  }, {});
  return {
    '#type': FORM_TYPE,
    '#fieldsByName': fieldsByName,
    '#fields': fields
  };
};
var getField = function getField(schema, key) {
  var field = schema['#fieldsByName'][key];
  return field;
};
var getFields = function getFields(schema) {
  return schema['#fields'];
};

export { createField, createForm, getField, getFields, isForm };
//# sourceMappingURL=schemaUtils.esm.js.map
